import ms from 'ms.macro'

export const QUOTE_POLLING_INTERVAL = ms`30sec`
